import React from 'react'

import { Modal } from 'Components/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'

import MobileView from './MobileView'
import { StyledSaveAdditionalInfoButton as StyledCloseButton } from '../styles'

const PreviewModal = ({ modalShow, additionalInfo, onCloseModal }) => (
  <Modal show={modalShow}>
    <ModalHeader>
      <ModalTitle>Mobile preview</ModalTitle>
    </ModalHeader>
    <ModalBody>
      <MobileView additionalInfo={additionalInfo} />
    </ModalBody>
    <ModalFooter>
      <StyledCloseButton onClick={onCloseModal}>Close</StyledCloseButton>
    </ModalFooter>
  </Modal>
)

export default PreviewModal
